export const STATUSES = {
  ACTIVE: 'Active',
  PASSIVE: 'Passive',
  HIRED: 'Hired',
  FIRED: 'Fired',
  REJECTED: 'Rejected',
  BLACKLISTED: 'Blacklisted',
} as const;

export type UserStatus = (typeof STATUSES)[keyof typeof STATUSES];
